import React, { useState, useCallback, useEffect } from "react";
import {
  Modal,
  Form,
  InputNumber,
  Checkbox,
  Button,
  Spin,
  message,
  Divider,
  Popconfirm,
  Space,
  Tooltip,
  Select,
  Radio,
  Input,
} from "antd";
import { FaFileInvoiceDollar } from "react-icons/fa";
import {
  DeleteOutlined,
  EditOutlined,
  SaveOutlined,
  CloseOutlined,
  PlusOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import { getImg } from "../../../Api/getImg";
import drEasyApi from "../../../Api/Customapi";
import { useInvoiceMutations } from "../../../hooks/useInvoice";
import { useClinics } from "../../../hooks/useClinics";
import { useQueryClient } from "@tanstack/react-query";
import { MdOutlineMedicalServices } from "react-icons/md";
     
 export const AddServicePanel = ({
  newServiceData,
  setNewServiceData,
  services,
  handleServiceTypeChange,
  handleServiceSelect,
  handleCancelAddService,
  handleAddServiceToInvoice,
  isAddServiceSubmitting,
  getEffectivePrice,
}) => (
  <div className="mb-3 p-4 bg-primary/5 rounded-lg border-2 border-primary/90">
    <div className="font-medium text-primary_hover mb-3">Add New Service</div>
    <div className="space-y-3">
      <div>
        <span className="text-sm text-gray-600 block mb-2">Service Type:</span>
        <Radio.Group
          value={newServiceData.serviceType}
          onChange={(e) => handleServiceTypeChange(e.target.value)}
          className="w-full"
        >
          <Radio.Button value="existing" className="w-1/2 text-center">
            Existing Service
          </Radio.Button>
          <Radio.Button value="external" className="w-1/2 text-center">
            External Service
          </Radio.Button>
        </Radio.Group>
      </div>

      {newServiceData.serviceType === "existing" ? (
        <div>
          <span className="text-sm text-gray-600 block mb-1">Select Service:</span>
          <Select
            placeholder="Choose a service"
            className="w-full"
            onChange={handleServiceSelect}
            value={newServiceData.serviceId}
            showSearch
            optionFilterProp="children"
          >
            {services?.map((service) => {
              const effective = getEffectivePrice(service);
              const hasDiscount = service.showDiscount && service.offerPercentage > 0;
              return (
                <Select.Option key={service.id} value={service.id}>
                  <div className="flex items-center gap-2">
                   {service.photoID? <img
                      src={getImg(service.photoID)}
                      className="w-6 h-6 rounded object-cover"
                      alt={service.title}
                    />:  <MdOutlineMedicalServices
                                                      className={`w-4 h-4 md:w-7 md:h-7 text-primary rounded-lg object-cover shadow-sm`}
                                                    />}
                    <span>{service.title}</span>
                    {hasDiscount ? (
                      <span className="text-green-600 font-semibold text-xs">
                        EGP {effective.toFixed(2)}
                        <span className="ml-1 line-through text-gray-400">
                          EGP {Number(service.price).toFixed(2)}
                        </span>
                      </span>
                    ) : (
                      <span className="text-gray-500 text-xs">
                        {service.price != null ? `EGP ${Number(service.price).toFixed(2)}` : ""}
                      </span>
                    )}
                  </div>
                </Select.Option>
              );
            })}
          </Select>
        </div>
      ) : (
        <div>
          <span className="text-sm text-gray-600 block mb-1">Service Title:</span>
          <Input
            autoFocus
            placeholder="e.g. Laser session, Custom wrap..."
            value={newServiceData.externalServiceTitle}
            onChange={(e) =>
              setNewServiceData({ ...newServiceData, externalServiceTitle: e.target.value })
            }
            onPressEnter={() => {
              document.getElementById("ext-unit-price")?.focus();
            }}
            allowClear
          />
        </div>
      )}

      <div className="grid grid-cols-2 gap-3">
        <div>
          <span className="text-sm text-gray-600 block mb-1">Unit Price:</span>
          <InputNumber
            id="ext-unit-price"
            min={0}
            value={newServiceData.unitPrice}
            onChange={(val) => setNewServiceData({ ...newServiceData, unitPrice: val || 0 })}
            className="w-full"
            prefix="EGP"
            step={0.01}
            precision={2}
          />
        </div>
        <div>
          <span className="text-sm text-gray-600 block mb-1">Quantity:</span>
          <InputNumber
            min={1}
            value={newServiceData.quantity}
            onChange={(val) => setNewServiceData({ ...newServiceData, quantity: val || 1 })}
            className="w-full"
          />
        </div>
      </div>

      <div className="text-right text-green-600 font-semibold">
        Total: EGP {(newServiceData.unitPrice * newServiceData.quantity).toFixed(2)}
      </div>

      <div className="flex justify-end gap-2">
        <Button size="small" onClick={handleCancelAddService} icon={<CloseOutlined />}>
          Cancel
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={handleAddServiceToInvoice}
          icon={<SaveOutlined />}
          loading={isAddServiceSubmitting}
          className="bg-green-500 border-green-500"
          disabled={
            (newServiceData.serviceType === "existing" && !newServiceData.serviceId) ||
            (newServiceData.serviceType === "external" &&
              !newServiceData.externalServiceTitle.trim())
          }
        >
          Add
        </Button>
      </div>
    </div>
  </div>
);